<template>
  <div class="porting-input">
    <p>Your current number</p>
    <input
      ref="porting-inputfield"
      v-model="inputText"
      v-mask="'(###) ###-####'"
      class="inputfield"
      placeholder="( _ _ _ ) _ _ _ - _ _ _ _"
      @keypress="onKeyPress"
    />
  </div>
</template>

<script>
export default {
  name: 'PortingNumberInput',
  props: {
    value: [String, Number]
  },
  computed: {
    inputText: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  },
  methods: {
    onKeyPress(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.porting-input {
  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #0d1d3f;
  }

  .inputfield {
    position: relative;
    width: 290px;
    height: 60px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid rgba(223, 225, 229, 0.7);
    box-sizing: border-box;
    color: $colorTitle;
    outline: none !important;
    font-family: Inter;
    font-weight: bold;
    font-size: 29px;
    line-height: 35px;
    padding: 0 25px;
    letter-spacing: -0.04em;

    &::placeholder {
      color: #c2c7cf;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .inputfield {
      width: 192px;
      height: 50px;
      font-weight: bold;
      font-size: 16px;
      line-height: 26px;
      padding: 0 12px;
    }
  }
}
</style>
